<template>
  <div>
    <generic-container
      :title="$t('account')"
      icon="book"
      :header_buttons="header_buttons"
    >
      <div class="ui four link cards">
        <div
          class="card"
          v-for="(item, index) in orders"
          :key="index"
          @click="select(item)"
        >
          <div class="content">
            <div
              class="ui red mini icon right floated button"
              @click.stop="remove(item, index)"
            >
              <i class="trash icon"></i>
            </div>
            <a class="ui right floated green label">{{
              item.setup.total | formatCurrency(enterprise_setup.currency_iso)
            }}</a>
            <div class="header">{{ item.name }}</div>
            <div class="description" style="margin-top: 20px;">
              <ul class="ui bulleted list">
                <li
                  class="item"
                  v-for="(prd, idx) in item.setup.products"
                  :key="idx"
                >
                  {{ prd.quantity }} x {{ prd.product.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <template v-for="(mdl, index) in item_modals">
        <component
          :is="mdl"
          :key="index"
          :item="selected_item"
          v-on:succedded="succedded"
        ></component>
      </template>
      <!-- <pre>{{ cart }}</pre> -->
    </generic-container>
  </div>
</template>

<script>
import { local_api, error_toast, enterprise_setup } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import _ from "lodash";
// import { error_toast } from "../../utils";

// @ is an alias to /src
export default {
  name: "PointOfSaleAccount",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      orders: [],
      item_modals: [],
      header_buttons: [
        {
          icon: "green refresh",
          tooltip: this.$t("refresh"),
          click: this.refresh,
        },
      ],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    add_order(order) {
      let trgtIndex = this.orders.findIndex((o) => o.uuid == order.uuid);
      console.log(trgtIndex);
      if (trgtIndex >= 0) this.orders.splice(trgtIndex, 1, order);
      else this.orders.push(order);
    },
    refresh() {
      let vm = this;
      local_api(vm, "post", "/point_of_sale/account/do-get-all")
        .then((accounts) => {
          vm.orders = accounts;
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    select(item) {
      this.$emit("select_account", _.clone(item));
    },
    remove(item, index) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove account?"),
        function() {
          local_api(vm, "post", "/point_of_sale/account/do-remove", {
            u: item.uuid,
          })
            .then((r) => {
              console.log(r);
              vm.orders.splice(index, 1);
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
  },
  mounted() {
    this.refresh();
  },
  watch: {},
};
</script>
